import AppHeader from "../../layout/AppHeader";
import PackageTable from '../../xpost/views/financial/package/PackageTable.vue';
import PackageTableAdd from '../../xpost/views/financial/package/PackageTableAdd.vue';

const PackageTableRoutes = [
    {
        path: "/cadastro/tabelapacote",
        name: "package.table",
        meta: {
            role: ['1'],
        },
        components: {
            header: AppHeader,
            default: PackageTable,
        }
    },
    {
        path: "/cadastro/tabelapacote/adicionar",
        name: "package.table.add",
        meta: {
            role: ['1'],
        },
        components: {
            header: AppHeader,
            default: PackageTableAdd,
        }
    },
    {
        path: '/cadastro/tabelapacote/adicionar/:id',
        name: 'package.table.edit',
        meta: {
            role: ['1'],
        },
        components: {
            header: AppHeader,
            default: PackageTableAdd,
        }
    }
]

export default PackageTableRoutes;